<template>

  <div>
      <div>
          <salaryTop :step.sync="step" @setStep="setStep"></salaryTop>
      </div>
      <router-view>

      </router-view>
  </div>

</template>

<script>

  import salaryTop from "@/views/wage/set/salaryTop.vue";
  export default {
    name: "salarySet",
    data(){
      return{
        step:1,

        // dialogheaderVisible:false,
      }
    },
    created(){
        this.step = this.$route.query.step?this.$route.query.step:1;
    },
    mounted(){
			
    },
    components: {salaryTop},
    methods:{
         setStep(id){
          this.step = id;
      },
    }
  };
</script>
